import { NOT_FOUND_STATUS_CODE } from '@/constants';
import { usePageProps } from '@/hooks';

function NotFoundPage() {
  const { routerContext } = usePageProps();
  if (routerContext) {
    routerContext.status = NOT_FOUND_STATUS_CODE;
  }

  return null;
}

export default NotFoundPage;
